import styled from 'styled-components';
import {Button, Space} from 'antd';
import {typographyStyles} from '../../../../utils/styles';

const StyledSpendingDetails = styled(Space)`
  width: 100%;

  .ant-card-head {
    min-height: 40px;
  }

  .ant-spin-container {
    display: flex;
    flex-direction: column;
  }


  & > .ant-space-item {
    display: flex;
  }
`;


const StyledSpendingDetailsCardExtra = styled.div`
  ${typographyStyles.footnote.medium};
  color: ${props => props.theme.colors.neutral_6};
`;

const StyledSpendingDetailsMoreButton = styled(Button)`
  ${typographyStyles.footnote.description};
  align-items: center;
  color: ${props => props.theme.colors.primary_6};
  display: flex;
  padding: 3px 0;
  margin: 8px auto 0 auto;
  width: max-content;

  &.ant-btn-variant-link {
    ${typographyStyles.footnote.description};
    color: ${props => props.theme.colors.primary_6};
  }
`;


const StyledSpendingDetailsOverflowSpace = styled(Space)`
    width: 100%;
    overflow: auto;
    height: calc(100vh - 162px);

    // Adjust padding if scrollbar is present
    @media (min-height: calc(100vh - 161px)) {
      padding-right: 5px;
    }
  `;
export {
  StyledSpendingDetails,
  StyledSpendingDetailsCardExtra,
  StyledSpendingDetailsMoreButton,
  StyledSpendingDetailsOverflowSpace
}
